import firebase from 'firebase/app';
import 'firebase/firestore';


// Initialize Firebase
var config = {
  apiKey: "AIzaSyCjWRnarcz5Ghx06X7Nnzu9b3wZp09br-M",
  authDomain: "thisweek-40a81.firebaseapp.com",
  projectId: "thisweek-40a81",
  storageBucket: "thisweek-40a81.appspot.com",
  messagingSenderId: "749861391043",
  appId: "1:749861391043:web:dfa1c8ba9b6ab3d7f9f076",
  measurementId: "G-DDPBTQ6N7C"
};
const firebaseApp = firebase.initializeApp(config);

// export firestore database
export default firebaseApp.firestore()
